import UserBrands from './UserBrands';

export default UserBrands;
